import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAnalysisProjectState } from '@shared/models';
import * as ResponseTypes from '@shared/models/analysis/analysis.response.type';
import { fetchAnalysisProjects } from '../queries';

const state: IAnalysisProjectState = {
    fetching: false,
    data: {
        projects: [],
        projectsCount: 0,
    },
    singleProject: null,
    quickAddProjects: [null],
    skillList: [],
    fetchingSkillList: false,
};

const anaylsisProjectSlice = createSlice({
    name: 'analysis-project',
    initialState: state,
    reducers: {
        setAnalysisProjects: (state, { payload }: PayloadAction<ResponseTypes.IFetchProjectsType>) => {
            state.data = payload;
        },
        setAnalysisSingleProject: (state, { payload }: PayloadAction<ResponseTypes.IFetchSingleProjectType>) => {
            state.singleProject = payload;
        },
        setQuickAddProjects: (state, { payload }: PayloadAction<string[]>) => {
            state.quickAddProjects = payload;
        },
        setSkillList: (state, { payload }: PayloadAction<ResponseTypes.IProjectSkillList>) => {
            state.skillList = payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchAnalysisProjects.pending, (state) => {
            state.fetching = true;
        });
        builder.addCase(fetchAnalysisProjects.rejected, (state) => {
            state.fetching = false;
        });
        builder.addCase(fetchAnalysisProjects.fulfilled, (state) => {
            state.fetching = false;
        });
    },
});

export const { setAnalysisProjects, setAnalysisSingleProject, setQuickAddProjects, setSkillList } =
    anaylsisProjectSlice.actions;
export default anaylsisProjectSlice.reducer;
